class MFRProductTop {
  constructor(i, e) {
    this.$index = i
    this.$element = $(e)

    this.selectors = {
      variantSelector: ".variant-selector",
      quantitySelector: ".quantity-selector",
      quantitySelectorContainer: ".product-top__quantity",
      quantitySelectorInput: ".quantity-selector__input",
      quantitySelectorIndicator: ".quantity-selector__count",
      quantityIncreaseBtn: ".quantity-selector__plus",
      quantityDecreaseBtn: ".quantity-selector__minus",
      form: ".product-top__form",
      price: ".product-top__submit .price",
      customQtySelector: ".custom-quantity-selector",
      stickyCounter: ".sticky-counter",
      stickyAtcContainer: ".product-top__atc",
      stickyAtcContainerMultiSelect: ".product-top__multi-select-atc",
      scrollToTopBtn: ".scroll-to-top-btn",
      galleryItem: ".gallery-item",
      mainSlider: "#main-slider",
      featuredImageContainer: ".product-top__featured-image",
      thumbnail: ".product-top__image-gallery-item"
    }

    this.counters = {
      minQuantity: 4,
      maxQuantity: 10
    }

    this.init()
  }

  init() {
    this.$form = this.$element.find(this.selectors.form)
    this.$variantSelector = this.$element.find(this.selectors.variantSelector)
    this.$price = this.$element.find(this.selectors.price)

    this.$mainSlider = this.$element.find(this.selectors.mainSlider);
    this.$galleryItem = this.$element.find(this.selectors.galleryItem);
    this.$thumbnail = this.$element.find(this.selectors.thumbnail);
    this.$firstFeaturedMedia = this.$element.find(`${this.selectors.thumbnail}:not(.main-gallery-item)`);
    this.$featuredImageContainer = this.$element.find(this.selectors.featuredImageContainer);

    this.$quantitySelector = this.$element.find(this.selectors.quantitySelector)
    this.$quantitySelectorContainer = this.$element.find(this.selectors.quantitySelectorContainer)
    this.$quantitySelectorInput = this.$element.find(this.selectors.quantitySelectorInput)
    this.$quantitySelectorIndicator = this.$element.find(this.selectors.quantitySelectorIndicator)
    this.$quantityIncreaseBtn = this.$element.find(this.selectors.quantityIncreaseBtn)
    this.$quantityDecreaseBtn = this.$element.find(this.selectors.quantityDecreaseBtn)
    this.$customQtySelector = this.$element.find(this.selectors.customQtySelector)

    this.$stickyAtcContainer = this.$element.find(this.selectors.stickyAtcContainer)
    this.$stickyAtcContainerMultiSelect = this.$element.find(this.selectors.stickyAtcContainerMultiSelect)
    this.$stickyCounter = this.$element.find(this.selectors.stickyCounter)
    this.$scrollToTopBtn = this.$element.find(this.selectors.scrollToTopBtn)

    this.__handleStickyAtcOnScroll()
    this.__handleImageTopClick()
    this.__handleInitMainImageLightGallery()

    this.$stickyCounter.find('.increase-btn').on("click", this.__handleStickyAtcIncreaseValue.bind(this))
    this.$stickyCounter.find('.decrease-btn').on("click", this.__handleStickyAtcDecreaseValue.bind(this))

    this.$customQtySelector.on("click", this.__handleSelectCustomQuantity.bind(this))
    this.$variantSelector.on("mfr:changed", this.__handleVariantChange.bind(this))
    this.$quantitySelector.on("mfr:quantity-changed", this.__handleQuantityChange.bind(this))

    this.$thumbnail.on("click", this.__handleThumbnailClick.bind(this));
    this.$scrollToTopBtn.on("click", this.__handleScrollToTop.bind(this));
  }

  __handleInitMainImageLightGallery() {
    if (!window.product_gallery) return

    const $mainSlider = document.getElementById("main-slider")

    if(!$mainSlider) return;

    const mainGallery = window.lightGallery($mainSlider, {
      dynamic: true,
      plugins: [lgZoom, lgThumbnail],
      download: false,
      hideScrollbar: true,
      speed: 500,
      actualSize: false,
      zoomFromOrigin: false,
      showZoomInOutIcons: true,
      dynamicEl: window.product_gallery
    })

    this.$mainLG = mainGallery;

    $mainSlider.addEventListener("click", () => {
      mainGallery.openGallery(0)
    })
  }

  __handleStickyAtcOnScroll() {
    if (!window.productStickyAtc) return
    let $stickyAtcContainer = this.$stickyAtcContainer.length > 0 ? this.$stickyAtcContainer: this.$stickyAtcContainerMultiSelect;
    let atcScrollTop = $($stickyAtcContainer).offset().top + $stickyAtcContainer.height() + 20
    $stickyAtcContainer.parent().css("min-height", `${ $stickyAtcContainer.height() + 20 }px`);

    const stickyContainer = (top, element) => {
      setTimeout(() => {
        top > atcScrollTop ? element.addClass('is-sticky') : element.removeClass('is-sticky')
      }, 500);
    }

    $(window).scroll(function() {
      let windowScrollTop = $(window).scrollTop()
      stickyContainer(windowScrollTop, $stickyAtcContainer)
    })

    stickyContainer($(window).scrollTop(), $stickyAtcContainer)
  }

  __handleScrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

  __handleSelectCustomQuantity(e) {
    const $currentTarget = $(e.currentTarget)
    const currentTargetQtyValue = Number($currentTarget.data("quantity"))

    $currentTarget.addClass("is-selected").siblings().removeClass("is-selected")

    this.$quantitySelectorInput.val(currentTargetQtyValue)
    this.$quantitySelectorIndicator.text(currentTargetQtyValue)
    this.$stickyCounter.find('.counter-value').text(currentTargetQtyValue)

    if (currentTargetQtyValue === 1) {
      this.$stickyCounter.find('.decrease-btn').prop("disabled", "disabled")
    } else {
      this.$stickyCounter.find('.decrease-btn').prop("disabled", "")
    }

    this.__handleMaxQuantitySelectorAction($currentTarget)
    this.__handleUpdatePrice()
    this.$quantitySelector.on("mfr:quantity-changed", this.__handleQuantitySelectorActionButtons.bind(this))
  }

  __handleQuantitySelectorActionButtons() {
    let currentQuantityValue = Number(this.$quantitySelectorInput.val())

    if (currentQuantityValue > this.counters.minQuantity) {
      this.$quantityDecreaseBtn.prop("disabled", "")
    } else if (currentQuantityValue <= this.counters.minQuantity) {
      this.$quantityDecreaseBtn.prop("disabled", "disabled")
    }

    if (currentQuantityValue >= this.counters.maxQuantity) {
      this.$quantityIncreaseBtn.prop("disabled", "disabled")
    } else if (currentQuantityValue < this.counters.maxQuantity) {
      this.$quantityIncreaseBtn.prop("disabled", "")
    }
  }

  __handleMaxQuantitySelectorAction(element) {
    if (element.hasClass("prompt-qty-input")) {
      this.$quantitySelectorContainer.removeClass("hide")
      this.$quantityDecreaseBtn.prop("disabled", "disabled")
    } else {
      this.$quantitySelectorContainer.addClass("hide")
      this.$quantityDecreaseBtn.prop("disabled", "")
    }
  }

  __handleStickyAtcValue(value) {
    this.$quantitySelectorInput.val(value)
    this.$stickyCounter.find('.counter-value').text(value)
    this.$quantitySelectorIndicator.text(value)
    this.__handleUpdatePrice()
    this.$element.trigger( "mfr:quantity-changed", [ parseInt( this.$quantitySelectorInput.val() ) ] )
  }

  __handleStickyAtcIncreaseValue(element) {
    let currentCount = parseInt(this.$quantitySelectorInput.val())
    this.__handleStickyAtcValue(currentCount + 1)

    // If the current quantity is greater than/equal to maxQuantity (which is set to 10)
    // Disable the increment(+) button(s) on default quantity selector as well as sticky component
    // Else, enable both
    if ((currentCount + 1) >= this.counters.maxQuantity) {
      $(element.currentTarget).prop("disabled", "disabled")
      this.$quantitySelector.find(this.selectors.quantityIncreaseBtn).prop("disabled", "disabled")
    } else {
      $(element.currentTarget).prop("disabled", "")
      this.$quantitySelector.find(this.selectors.quantityIncreaseBtn).prop("disabled", "")
    }

    // If the current quantity is more than one
    // Enable the decrement(-) button(s) on default quantity selector as well as sticky component
    if ((currentCount + 1) > 1) {
      $(element.currentTarget).siblings('.decrease-btn').prop("disabled", "")
      this.$quantitySelector.find(this.selectors.quantityDecreaseBtn).prop("disabled", "")
    }

    // If the current quantity is greater than/equal to minQuantity (which is set to 4)
    // (1) Show the default quantity selector
    // (2) Update the custom quantity selector active states
    if ((currentCount + 1) >= this.counters.minQuantity) {
      this.$quantitySelectorContainer.removeClass('hide')
      $('.custom-quantity-selector.prompt-qty-input').addClass('is-selected').siblings().removeClass('is-selected')
    } else {
      $(`.custom-quantity-selector[data-quantity="${currentCount + 1}"]`).addClass('is-selected').siblings().removeClass('is-selected')
    }
  }

  __handleStickyAtcDecreaseValue(element) {
    let currentCount = parseInt(this.$quantitySelectorInput.val())
    this.__handleStickyAtcValue(currentCount - 1)

    // If the current quantity is equal to one (minimum possible quantity)
    // Disable the decrement(-) button(s) on default quantity selector as well as sticky component
    // Else, enable the decrement(-) button(s) on default quantity selector as well as sticky component
    if ((currentCount - 1) === 1) {
      $(element.currentTarget).prop("disabled", "disabled")
      this.$quantitySelector.find(this.selectors.quantityDecreaseBtn).prop("disabled", "disabled")
    } else {
      $(element.currentTarget).prop("disabled", "")
      this.$quantitySelector.find(this.selectors.quantityDecreaseBtn).prop("disabled", "")
      this.$quantitySelector.find(this.selectors.quantityIncreaseBtn).prop("disabled", "")
    }

    // If the current quantity is less than minQuantity (which is set to 4)
    // (1) Hide the default quantity selector
    // (2) Update the custom quantity selector active states
    if ((currentCount - 1) < this.counters.minQuantity) {
      this.$quantitySelectorContainer.addClass('hide')
      $('.custom-quantity-selector.prompt-qty-input').removeClass('is-selected')
      $(`.custom-quantity-selector[data-quantity="${currentCount - 1}"]`).addClass('is-selected').siblings().removeClass('is-selected')
    }

    // Always enable the increment(+) button on sticky component
    $(element.currentTarget).siblings('.increase-btn').prop("disabled", "")
  }

  __handleVariantChange(e, data) {
    if (this.$quantitySelector.length) {
      if (Alpine.store('variantMultiSelect').selectedQuantity) {
        this.$quantitySelector.mfrQuantitySelector("set-quantity", Alpine.store('variantMultiSelect').selectedQuantity)
      } else {
        this.$quantitySelector.mfrQuantitySelector("set-quantity", 1)
      }
      this.$quantitySelector.data("max", data.max)
    }

    this.__handleUpdatePrice()
  }

  __handleQuantityChange(e, data) {
    this.__handleUpdatePrice()
    this.$stickyCounter.find('.counter-value').text(data)
  }

  __handleUpdatePrice() {
    if (!this.$price.length) return

    const basePrice = parseFloat(this.$form.data("base-price"))
    const quantity = this.$quantitySelector.length ? Number(this.$quantitySelector.mfrQuantitySelector("get-quantity")) : 1
    const currentPrice = basePrice * quantity

    this.$price.html(Alpine.store('methods').formatMoney(currentPrice))
  }

  __handleFormatValue(value, decimal_point) {
    return +parseFloat(value).toFixed(decimal_point)
  }

  __handleImageTopClick() {
    this.$mainSlider.on("click", (e) => {
      if(e.originalEvent) {
        if(e.target.tagName == "BUTTON" || e.target.closest(".mfr-components__video")) {
          e.preventDefault();
          $(e.target).closest(".mfr-components__video").click();
          $("#lg-container-1").css("display", "none");
          this.$mainLG.closeGallery(0);
        } else {
          $("#lg-container-1").css("display", "");
          $(this).click();
          return;
        }
      }
    })
  }

  __handleThumbnailClick(e) {
    const element = $(e.currentTarget);
    const media = element.html();
    const video = element.find("video");

    this.$mainSlider.find(".mfr-components__video").remove();

    if (video.length > 0) {
      $(video).get(0).pause();

      this.$mainSlider.append(media);
      this.$galleryItem.hide();

      this.$featuredImageContainer.find(".mfr-components__video--hosted-video").each((i, e) => {
        const mfrHostedVideo = new MFRHostedVideo(i, e)
      });

      this.$featuredImageContainer.find(".zoom-icon").hide();
      this.$featuredImageContainer.find(".mfr-components__video--hosted-video video").get(0).play();
    } else {
      this.$galleryItem.find(".gallery-item-container").html(media);
      this.$featuredImageContainer.find(".zoom-icon").show();
      this.$galleryItem.show();
    }

    if(!element.hasClass("main-gallery-item") || media.indexOf(".png") < 0) {
      // for featured media
      this.$galleryItem.find(".gallery-item-container").addClass('preview-media')
      this.$featuredImageContainer.addClass("preview-gallery")
      this.$galleryItem.find(".gallery-item-container").removeClass('has-shadow')
    } else {
      // for main product top image (usually png)
      this.$galleryItem.find(".gallery-item-container").removeClass('preview-media')
      this.$featuredImageContainer.removeClass("preview-gallery")
      this.$galleryItem.find(".gallery-item-container").addClass('has-shadow')
      this.$galleryItem.find(".gallery-item-container img").addClass("image-contain");
    }

    // const firstFeaturedMedia = $()

  }
}